import { useEffect, useRef, useState } from 'react';
import styles from './SectionAvis.module.css';

function SectionAvis() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return () => {};
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '200px' },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles.bg}>
      <div className={styles.container} ref={ref}>
        {visible && (
          <iframe
            src="https://www.societe-des-avis-garantis.fr/wp-content/plugins/ag-core/widgets/iframe/2/h/?id=11853"
            title="Avis vérifiés"
            height={221}
            width="100%"
          />
        )}
      </div>
    </div>
  );
}

export default SectionAvis;
